import React from "react";
import { Link } from "react-router-dom";

export default function Events({ events }) {
  return (
    <div className="">
      <div className="bg-ambhosLiteOrange -mx-4 md:-mx-8">
        <h1 className="text-3xl md:text-4xl font-semibold inline-block py-2 px-5 my-5 ml-4 md:ml-24 text-gray-800">
          Events
        </h1>
      </div>
      <div className="mt-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {events.map((event) => (
          <div
            key={event._id}
            className="flex flex-col justify-center items-center rounded-lg text-center"
          >
            <Link to={`/events/${event._id}`}>
              <img
                src={event?.images[0] ? event?.images[0] : ""}
                className="rounded-lg object-cover w-full h-64"
                alt=""
              />
              <p className="mt-2 font-semibold">{event.eventName}</p>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
